var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_686_11579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5835 6.19141H6.66683M3.3335 6.19141H3.33724M5.41683 7.85807H3.3335M6.66683 7.85807H6.66308",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1.60938V2.44271M2.5 1.60938V2.44271",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.0415 5.87672C1.0415 4.0612 1.0415 3.15342 1.56322 2.58941C2.08494 2.02539 2.92462 2.02539 4.604 2.02539H5.39567C7.07505 2.02539 7.91475 2.02539 8.43646 2.58941C8.95817 3.15342 8.95817 4.0612 8.95817 5.87672V6.09072C8.95817 7.90627 8.95817 8.81402 8.43646 9.37806C7.91475 9.94206 7.07505 9.94206 5.39567 9.94206H4.604C2.92462 9.94206 2.08494 9.94206 1.56322 9.37806C1.0415 8.81402 1.0415 7.90627 1.0415 6.09072V5.87672Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 4.10938H8.75",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_686_11579"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(0 0.775391)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.b1201b44f50cd9b6ee7c341880ae4f96.svg";
export { ForwardRef as ReactComponent };